import React from 'react';
import ContentIconAtom from '@atoms/icon-atoms/content-icon-atoms';
import Translate from '@utils/translation-functions';
import {
  Align,
  FooterWrapper,
  LinksContainer,
  Newsletter,
  StyledLink,
} from './navbar-footer.styles';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import { NavbarFooterProps } from './navbar-footer.types';

export const NavbarFooter: React.FC<NavbarFooterProps> = ({
  footerLinks,
  translate = true,
}) => {
  return (
    <FooterWrapper>
      <LinksContainer>
        <Align>
          <Newsletter>
            <StyledLink
              data-gtm-id={GTM_ID.FLYOVER_LINK_FOOTER}
              to="/newsletter-sign-up"
            >
              {Translate('Newsletter sign up', translate)}
            </StyledLink>
          </Newsletter>
        </Align>
        <Align>
          {footerLinks.map((link, i) => {
            return (
              <Align key={i}>
                <StyledLink
                  to={link.path}
                  isExternal={link.isExternal}
                  data-gtm-id={GTM_ID.FLYOVER_LINK_FOOTER}
                >
                  {link.title}
                  {link.isExternal && (
                    <ContentIconAtom
                      width={24}
                      height={24}
                      backgroundFill="transparent"
                      fill="#ccc"
                      contentType={'externalLink'}
                    />
                  )}
                </StyledLink>
              </Align>
            );
          })}
        </Align>
      </LinksContainer>
    </FooterWrapper>
  );
};
